import { getUrlFromMultipleQueryParams } from './index';

export const IS_TRADING_ALLOWED_URL = (type, isUnlisted) => getUrlFromMultipleQueryParams('/is-trading-allowed', {
    type, isUnlisted,
});